import { render } from "./PrecognitionIcon.vue?vue&type=template&id=156bf362&scoped=true"
import script from "./PrecognitionIcon.vue?vue&type=script&lang=js"
export * from "./PrecognitionIcon.vue?vue&type=script&lang=js"

import "./PrecognitionIcon.vue?vue&type=style&index=0&id=156bf362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156bf362"]])

export default __exports__